export default {
  bbacontact: {
    default: 'Contact BBA | Contacts BBA',
    list: {
      page_title: 'Liste des contacts BBA'
    },
    edit: {
      page_title: 'Modification du contact BBA :'
    },
    show: {
      page_title: 'Fiche contact BBA : '
    }
  }
}
